export type StandardMVCJsonResponseBase = {
    isSuccess: boolean;
    hasMessage: boolean;
    message: string;
    data: { [key: string]: any }
}